export default "__VITE_ASSET__DrBB0HqE__"